import { render } from "./CustomersSpendChart.vue?vue&type=template&id=2d2a66d5"
import script from "./CustomersSpendChart.vue?vue&type=script&lang=js"
export * from "./CustomersSpendChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CustomersSpendChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d2a66d5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d2a66d5', __exports__)) {
    console.log('reload')
    api.reload('2d2a66d5', __exports__)
  }
  
  module.hot.accept("./CustomersSpendChart.vue?vue&type=template&id=2d2a66d5", () => {
    console.log('re-render')
    api.rerender('2d2a66d5', render)
  })

}


export default __exports__